'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
import { INITIAL_STATE as PUBLIC_INITIAL_STATE, updateAchievements } from './PublicAchievement';
export const INITIAL_STATE = PUBLIC_INITIAL_STATE.merge({
  byTrack: ImmutableMap({})
});
export const publicIdsByTrack = achievements => achievements.reduce((memo, ach, publicId) => ach.get('tracks', List()).size === 1 ? memo.set(ach.get('tracks', List()).first().toString(), publicId) : memo, ImmutableMap());
export default function Achievement(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.ACHIEVEMENT_CREATE_REQUESTING:
      return state.mergeIn(['byId', action.payload.temporaryId], {
        isRequesting: true,
        hasError: false
      }).setIn(['byTrack', action.payload.trackId], action.payload.temporaryId);

    case ActionTypes.ACHIEVEMENT_UPDATE_REQUESTING:
      return state.mergeIn(['byId', action.payload.publicId], {
        isRequesting: true,
        hasError: false
      });

    case ActionTypes.ACHIEVEMENT_CREATE_SUCCEEDED:
      {
        const {
          language,
          response,
          temporaryId
        } = action.payload;
        return updateAchievements(state, response, language).deleteIn(['byId', temporaryId]).mergeIn(['byTrack'], publicIdsByTrack(response.get('achievements')));
      }

    case ActionTypes.ACHIEVEMENT_UPDATE_SUCCEEDED:
      return state.mergeDeepIn(['byId', action.payload.publicId], action.payload.data, {
        isRequesting: false,
        hasError: false
      });

    case ActionTypes.ACHIEVEMENT_CREATE_ERROR:
      return state.mergeIn(['byId', action.payload.temporaryId], {
        isRequesting: false,
        hasError: true,
        error: action.payload
      });

    case ActionTypes.ACHIEVEMENT_UPDATE_ERROR:
      return state.mergeIn(['byId', action.payload.publicId], {
        isRequesting: false,
        hasError: true,
        error: action.payload
      });

    case ActionTypes.ACHIEVEMENTS_ALL_REQUESTING:
      return state.merge({
        isRequestingAll: true,
        recentAllRequestError: undefined
      });

    case ActionTypes.ACHIEVEMENTS_ALL_RECEIVED:
      {
        const {
          preferredLanguage,
          response
        } = action.payload;
        return updateAchievements(state, response, preferredLanguage).merge({
          isRequestingAll: false,
          recentAllRequestError: undefined
        }).mergeIn(['byTrack'], publicIdsByTrack(response.get('achievements')));
      }

    case ActionTypes.ACHIEVEMENTS_ALL_ERROR:
      return state.merge({
        isRequestingAll: false,
        recentAllRequestError: action.payload
      });

    default:
      return state;
  }
}